<template>
  <div class="render">
    <div class="top">
      <h1>Оценка вероятности дозвона</h1>
      <a
        class="api-instruction"
        href="/score_api.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        Инструкция для api
      </a>
    </div>

    <div class="my_toolbar">
      <v-tabs v-model="tab" align-with-title class="tabs">
        <v-tabs-slider color="#4B5EFF" />
        <v-tab
          v-for="item in tabs"
          :key="item"
          class="item_tab"
          active-class="my_active_tab"
        >
          {{ item }}
        </v-tab>
      </v-tabs>

      <div class="add" @click.stop="openCreateDialog">
        <Icon name="white_plus" />
        Создать заявку
      </div>
      <v-dialog
        v-model="confirmDelete.open"
        max-width="565"
        transition="dialog-bottom-transition"
      >
        <v-card class="snm modal-card">
          <v-btn
            icon
            class="close-btn"
            @click.stop="confirmDeleteNo"
            aria-label="Закрыть"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <h2 class="modal-title">Удалить заявку?</h2>

          <div class="form-control">
            <div class="field" style="font-weight: 700">
              {{ confirmDelete.row?.name || '—' }}
            </div>
          </div>

          <div class="form-control">
            <div class="muted" style="text-align: center">
              Действие необратимо. Будут удалены все номера и результаты по
              заявке.
            </div>
          </div>

          <div class="actions">
            <v-btn class="ghost-btn" height="44" @click="confirmDeleteNo"
              >Отмена</v-btn
            >
            <v-btn
              class="primary-btn"
              height="44"
              :loading="confirmDelete.loading"
              :disabled="confirmDelete.loading"
              @click="confirmDeleteYes"
            >
              Удалить
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>

    <v-dialog v-model="createDialog" width="560">
      <v-card class="wrapper">
        <v-card-title
          class="d-flex align-center justify-space-between pa-0 mb-4"
        >
          <div class="text-h6 font-weight-bold">Создать заявку</div>
          <v-btn
            icon
            class="dialog-close"
            @click="closeCreateDialog"
            aria-label="Закрыть"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-text-field
          v-model="createForm.name"
          label="Название заявки"
          placeholder="Например: «Анализ по базе от 10.10»"
          :rules="[
            (v) => !!v || 'Обязательное поле',
            (v) => (v || '').length <= 100 || 'До 100 символов',
          ]"
        />
        <v-checkbox
          v-model="createForm.autoFillBases"
          class="mt-2"
          hide-details
          color="#4B5EFF"
          label="Добавить номера сразу в базу"
          @change="onToggleAutoFillBases"
        />
        <v-checkbox
          v-model="saveCustomFields"
          class="mt-2"
          hide-details
          color="#4B5EFF"
          label="Сохранять кастомные поля из файла"
        />

        <div v-if="createForm.autoFillBases" class="mt-2">
          <v-radio-group
            v-model="createForm.baseMode"
            row
            class="mt-2 my-radio-group"
            hide-details
          >
            <v-radio
              color="#4B5EFF"
              label="В существующую базу"
              value="existing"
            />
            <v-radio color="#4B5EFF" label="Создать новую базу" value="new" />
          </v-radio-group>

          <div class="score-base-params">
            <BaseParams
              :params="createForm.params"
              @updateParams="(v) => (createForm.params = v)"
            />
          </div>

          <v-select
            v-if="createForm.baseMode === 'existing' && !createForm.addToGroup"
            v-model="createForm.baseId"
            :items="baseOptions"
            item-text="name"
            item-value="id"
            clearable
            label="Выберите базу для заливки"
            :loading="basesLoading"
            :disabled="basesLoading"
          />
          <div v-if="dedupeWarningText" class="rules rules--warning">
            {{ dedupeWarningText }}
          </div>
          <v-text-field
            v-if="createForm.baseMode === 'new'"
            v-model="createForm.newBaseName"
            label="Название новой базы"
            placeholder="Например: База после скоринга 10.10"
          />

          <v-checkbox
            v-model="createForm.addToGroup"
            label="Добавить базу в группу"
            color="#4B5EFF"
          />

          <v-text-field
            v-if="createForm.addToGroup && createForm.baseMode === 'new'"
            v-model="createForm.groupName"
            label="Введите название группы"
          />

          <v-select
            v-if="createForm.addToGroup && createForm.baseMode === 'existing'"
            v-model="createForm.groupName"
            :items="groupOptions"
            label="Выберите группу"
          />

          <v-checkbox
            v-if="createForm.baseMode === 'new'"
            v-model="createForm.splitBase"
            label="Разбить на несколько частей"
            color="#4B5EFF"
          />

          <v-text-field
            v-if="createForm.baseMode === 'new' && createForm.splitBase"
            v-model.number="createForm.splitCount"
            type="number"
            label="Количество частей"
          />

          <v-checkbox
            v-model="createForm.useSourceFromFile"
            class="mt-2"
            hide-details
            color="#4B5EFF"
            label="Брать источник из файла"
          />

          <div class="min-percent">
            <div class="min-percent__label">
              Не добавлять контакты с вероятностью менее
            </div>

            <v-slider
              v-model="createForm.minPercent"
              class="min-percent__slider"
              :min="0"
              :max="100"
              :step="1"
              thumb-label
            />

            <div class="min-percent__value">
              Порог: <b>{{ createForm.minPercent }}%</b>
            </div>
          </div>

          <v-checkbox
            v-model="createForm.autoFillIncludeZeroScore"
            label="Добавить контакты, по которым нет данных"
            hide-details
            color="#4B5EFF"
            class="zero-score-checkbox"
          />

          <div
            class="rules rules--error"
            v-if="
              createForm.baseMode === 'existing' &&
              !basesLoading &&
              !createForm.baseId
            "
          >
            Выберите хотя бы одну базу для заливки.
          </div>
          <div
            class="rules rules--error"
            v-if="createForm.baseMode === 'new' && !createForm.newBaseName"
          >
            Укажите название новой базы.
          </div>
        </div>
        <div class="subtitle">Загрузите номера телефонов</div>
        <div class="textarea">
          <uploader-file
            ref="uploader"
            :name="createForm.name"
            :unique="false"
            :params="{}"
            :clear-file="clearFileFlag"
            :hide-custom-columns="!saveCustomFields"
            @clear-file="(v) => (clearFileFlag = v)"
            @file-meta="onFileMeta"
            @columns="onPhoneColumnSelected"
          />
        </div>

        <div v-if="fileMeta" class="rules">
          Найдено строк: <b>{{ fileMeta.rowCount }}</b
          >. Стоимость заявки: <b>{{ priceFormatted }}</b
          >.<br />
          Выберите колонку с номерами в блоке выше.
        </div>

        <v-progress-linear
          v-if="createLoading || ingesting"
          class="mt-3"
          indeterminate
          height="10"
          color="#4B5EFF"
        />

        <div
          class="add add_modal"
          style="margin-top: 10px"
          :class="{
            'opacity-50 pointer-events-none':
              !canCreate || createLoading || ingesting,
          }"
          @click="createRequest"
        >
          Создать заявку
        </div>
        <div v-if="createForm.autoFillBases" class="rules">
          Добавляя базу номеров Вы подтверждаете факт получения Вами явного
          согласия от каждого абонента в загружаемой базе на получение рекламной
          информации в соответствии с ч. 1 и 2 ст. 18 Закона «О рекламе»
        </div>
      </v-card>
    </v-dialog>

    <div class="content_table">
      <v-tabs-items v-model="tab">
        <v-tab-item :key="tabs[0]">
          <FilterReports
            :page_type="'score_requests'"
            :selects="selects_load"
            :filterConfig="requestsFilterConfig"
            :callback="renderRequests"
            :hide-export="true"
            @export="exportRequests"
            class="score-filters"
          />
          <Table
            :server="false"
            :hideselect="true"
            :loading="loading_requests || scoreExportLoading"
            :headers="table.headers_requests"
            :data="table.requests.data"
            :perPage="perPage"
            :callback_refresh="renderRequests"
            page_type="score_requests"
            :items="requestActions"
            :itemsFn="requestItemsFn"
            @delete="onClickDelete"
            @export="exportRow"
          />
        </v-tab-item>

        <v-tab-item :key="tabs[1]">
          <FilterReports
            :page_type="'score_numbers'"
            :selects="selects_load"
            :filterConfig="numbersFilterConfig"
            :callback="renderNumbers"
            @export="exportNumbers"
            class="score-filters"
          />
          <Table
            :server="true"
            :hideselect="true"
            :loading="loading_numbers || scoreExportLoading"
            :headers="table.headers_numbers"
            :data="table.numbers.data"
            :perPage="perPage"
            :pageCount_server="numbersTotal"
            :callback_refresh="renderNumbers"
            page_type="score_numbers"
          />
        </v-tab-item>
      </v-tabs-items>
    </div>
    <v-snackbar
      v-model="scoreExportNotice.show"
      :timeout="5000"
      :z-index="2100"
      top
      right
      color="white"
      class="score-export-notice"
      role="status"
      aria-live="polite"
    >
      <div class="score-export-notice-content">
        <v-icon :color="scoreExportNotice.error ? '#E05252' : '#4B5EFF'">
          {{ scoreExportNotice.error ? 'mdi-alert-circle-outline' : 'mdi-check-circle-outline' }}
        </v-icon>
        <span>{{ scoreExportNotice.text }}</span>
      </div>
      <template #action="{ attrs }">
        <v-btn icon v-bind="attrs" color="#757575" aria-label="Закрыть уведомление" @click="scoreExportNotice.show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Table from '@/components/Table/DataTable.vue';
import FilterReports from '@/components/Filter/ReportsFilter.vue';
import Icon from '@/components/SetIcon.vue';
import UploaderFile from '@/components/FileUploader.vue';
import BaseParams from '@/components/Modal/Bases/Form/BaseParams.vue';
// const SCORE_PERCENT_OPTIONS = [0, 0.5, 1, 1.5, 2, 3, 5, 20, 35, 40, 45, 50]

function defaultCreateForm() {
  return {
    name: '',
    autoFillBases: false,
    baseId: null,
    minPercent: 20,
    baseMode: 'existing',
    newBaseName: '',
    autoFillIncludeZeroScore: false,
    splitBase: false,
    splitCount: 1,
    useSourceFromFile: false,
    addToGroup: false,
    groupName: '',
    params: {
      autodelete: true,
      day: 30,
    },
  };
}
export default {
  name: 'ScoreNumbersPage',
  components: {
    Table,
    FilterReports,
    Icon,
    'uploader-file': UploaderFile,
    BaseParams,
  },
  data() {
    return {
      confirmDelete: { open: false, row: null, loading: false },
      numbersTotal: 0,
      selects_load: { request_names: [] },
      createDialog: false,
      createForm: defaultCreateForm(),
      fileMeta: null,
      clearFileFlag: false,
      importProgress: 0,
      lastNumbersFilters: {},
      createLoading: false,
      ingesting: false,
      phoneColumnPicked: false,
      lastUploadPayload: null,
      baseOptions: [],
      basesLoading: false,
      saveCustomFields: true,
      selectedCustomFields: [],
      groupOptions: [],
      scoreExportLoading: false,
      scoreExportNotice: { show: false, text: '', error: false },
      // scorePercentOptions: SCORE_PERCENT_OPTIONS.map(v => ({ text: `${v}%`, value: v })),

      priceValue: 0,
      scorePrice: 0.1,

      tab: 'Ваши заявки',
      tabs: ['Ваши заявки', 'Проверенные номера'],
      perPage: 10,
      loading_requests: true,
      loading_numbers: true,

      requestsFilterConfig: [
        {
          field: 'request_name',
          type: 'select',
          label: 'Название заявки',
          items: 'request_names',
          multiple: true,
        },
      ],
      numbersFilterConfig: [
        {
          field: 'request_name',
          type: 'select',
          label: 'Название заявки',
          items: 'request_names',
          multiple: true,
        },
        { field: 'score_percent', type: 'range', label: 'Вероятность дозвона' },
        {
          field: 'include_zero_score',
          type: 'checkbox',
          label: 'Включать скор 0',
        },
      ],

      table: {
        requests: { data: [] },
        numbers: { data: [] },
        headers_requests: [
          { text: 'Название', value: 'name' },
          { text: 'Статус', value: 'status' },
          { text: 'Прогресс', value: 'progress' },
          { text: 'Всего номеров', value: 'uploaded_count' },
          { text: 'Номеров оценено', value: 'scored_count' },
          { text: 'Стоимость', value: 'price', cellClass: 'no-wrap' },
          { text: 'Дата создания', value: 'created_at_raw' },
          { text: '', value: 'actions', sortable: false, align: 'end' },
        ],
        headers_numbers: [
          { text: 'Номер', value: 'phone' },
          { text: 'Название заявки', value: 'request_name' },
          { text: 'Дата проверки', value: 'score_date' },
          { text: 'Процент проверки', value: 'score_percent' },
        ],
      },

      requestActions: [],
    };
  },
  computed: {
    dedupeWarningText() {
      if (!this.createForm.autoFillBases) return '';
      if (this.createForm.addToGroup) return '';

      if (this.createForm.baseMode === 'existing') {
        const base = this.baseOptions.find(
          (b) => b.id === this.createForm.baseId,
        );

        if (base?.unique) {
          return 'Выбрана база с дедупликацией. После скоринга выбранные для загрузки контакты могут загрузиться в базу не в полном объёме, если эти контакты уже были загружены ранее';
        }
      }

      return '';
    },
    priceFormatted() {
      return new Intl.NumberFormat('ru-RU', {
        style: 'currency',
        currency: 'RUB',
      }).format(Number(this.priceValue || 0));
    },
    canCreate() {
      const baseOk = !!this.createForm.name && !!this.phoneColumnPicked;
      if (!this.createForm.autoFillBases) return baseOk;

      const minOk =
        this.createForm.minPercent !== null &&
        this.createForm.minPercent !== '' &&
        this.createForm.minPercent !== undefined;

      if (this.createForm.baseMode === 'existing') {
        if (this.createForm.addToGroup) {
          return baseOk && !!this.createForm.groupName && minOk;
        }

        return baseOk && !!this.createForm.baseId && minOk;
      }

      if (this.createForm.baseMode === 'new') {
        return (
          baseOk && !!String(this.createForm.newBaseName || '').trim() && minOk
        );
      }

      return false;
    },
  },
  mounted() {
    this.fetchScorePrice()
      .catch(() => {})
      .finally(() => {
        this.fetchRequestNames().then(() => {
          this.renderRequests();
          this.renderNumbers();
        });
      });
  },
  methods: {
    async downloadScoreExport(payload, filename) {
      if (this.scoreExportLoading) return;

      this.scoreExportLoading = true;
      this.scoreExportNotice.show = false;
      const exportStartedAt = performance.now();

      try {
        const body = sessionStorage.token
          ? { ...payload, token: sessionStorage.token }
          : payload;

        const { data } = await this.$http.axios.post(
          '/score/numbers/export',
          body,
          { responseType: 'blob' },
        );

        // Минимум 5 секунд с начала экспорта, включая ожидание сервера.
        const remainingDelay = 5000 - (performance.now() - exportStartedAt);
        if (remainingDelay > 0) {
          await new Promise(resolve => setTimeout(resolve, remainingDelay));
        }

        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download = filename;
        document.body.appendChild(link);

        try {
          link.click();
        } finally {
          link.remove();
          setTimeout(() => URL.revokeObjectURL(url), 1000);
        }

      } catch (err) {
        console.error('Ошибка экспорта скоринга:', err);
        let errorData = err.response?.data;
        if (errorData instanceof Blob) {
          try {
            errorData = JSON.parse(await errorData.text());
          } catch {
            errorData = null;
          }
        }
        this.scoreExportNotice = {
          show: true,
          text: errorData?.error === 'not ready'
            ? 'Скоринг заявки ещё не завершён. Экспорт будет доступен после завершения обработки'
            : 'Не удалось скачать отчёт. Попробуйте ещё раз',
          error: true,
        };
      } finally {
        this.scoreExportLoading = false;
      }
    },
    async fetchUserBases() {
      this.basesLoading = true;
      try {
        const params = sessionStorage.token
          ? { token: sessionStorage.token }
          : {};
        const resp = await this.$http.axios.get('/score/bases/options', {
          params,
        });
        const rows = Array.isArray(resp.data) ? resp.data : [];
        this.baseOptions = rows
          .map((r) => ({
            id: String(r?.id || '').trim(),
            name: String(r?.name || r?.id || '').trim(),
            groupName: String(r?.groupName || '').trim(),
            unique: !!r?.unique,
            uniqtype: String(r?.uniqtype || 'uploaded'),
          }))
          .filter((r) => r.id);

        this.groupOptions = this.baseOptions
          .map((r) => r.groupName)
          .filter(Boolean)
          .filter((v, i, a) => a.indexOf(v) === i);

        if (!this.createForm.baseId && this.baseOptions.length === 1) {
          this.createForm.baseId = this.baseOptions[0].id;
        }
      } catch (e) {
        console.error('fetchUserBases error', e);
        this.baseOptions = [];
      } finally {
        this.basesLoading = false;
      }
    },

    async onToggleAutoFillBases(val) {
      if (val) {
        this.createForm.baseMode = 'existing';
        this.createForm.baseId = null;
        this.createForm.newBaseName = '';
        await this.fetchUserBases();
      } else {
        this.createForm.baseId = null;
        this.createForm.newBaseName = '';
        this.createForm.baseMode = 'existing';
      }
    },
    async fetchScorePrice() {
      try {
        const params = {};
        if (sessionStorage.token) {
          params.token = sessionStorage.token;
        }

        const resp = await this.$http.axios.get('/score/price', { params });

        const p = Number(resp.data?.price);
        this.scorePrice = Number.isFinite(p) && p >= 0 ? p : 0.1;
      } catch (e) {
        console.error('fetchScorePrice error', e);
        this.scorePrice = 0.1;
      }
    },
    onClickDelete(row) {
      const r = Array.isArray(row) ? row[0] : row;
      if (!r) return;
      this.confirmDelete.row = r;
      this.confirmDelete.open = true;
    },

    confirmDeleteNo() {
      this.confirmDelete.open = false;
      this.confirmDelete.loading = false;
      this.confirmDelete.row = null;
    },

    async confirmDeleteYes() {
      const row = this.confirmDelete.row;
      if (!row?.request_id) {
        this.confirmDeleteNo();
        return;
      }

      try {
        this.confirmDelete.loading = true;
        await this.$http.post(
          '/score/requests/delete',
          { request_id: row.request_id },
          () => {},
        );
        this.confirmDelete.loading = false;
        this.confirmDelete.open = false;
        this.confirmDelete.row = null;
        this.renderRequests();
        this.renderNumbers();
      } catch (e) {
        this.confirmDelete.loading = false;
        this.confirmDelete.open = false;
        const err = e?.response?.data;
        if (err?.error === 'not_allowed' || err?.status === 'not_allowed') {
          alert(
            'Удаление доступно только для заявок со статусом «Готово» или «Ошибка».',
          );
        } else if (err?.error === 'not_found') {
          alert('Заявка не найдена.');
        } else {
          alert('Не удалось удалить заявку.');
        }
      }
    },

    exportRow(row) {
      const request_id = row?.request_id;
      if (!request_id) return;

      return this.downloadScoreExport(
        { request_id },
        `${row.name || 'score'}.xlsx`,
      );
    },

    async fetchRequestNames() {
      try {
        const rows = await new Promise((resolve) => {
          this.$http.post('/score/requests/options', {}, (data) =>
            resolve(data || []),
          );
        });
        this.selects_load.request_names = rows
          .map((r) => String(r.name || '').trim())
          .filter(Boolean)
          .filter((v, i, a) => a.indexOf(v) === i)
          .map((name) => ({ id: name, name }));
      } catch (e) {
        console.error('fetchRequestNames error', e);
        this.selects_load.request_names = [];
      }
    },

    async openCreateDialog() {
      try {
        await this.fetchScorePrice();
      } catch (e) {
        console.log(e);
      }
      this.createDialog = true;
      this.createForm = defaultCreateForm();
      this.fileMeta = null;
      this.phoneColumnPicked = false;
      this.lastUploadPayload = null;
      this.priceValue = 0;
      this.importProgress = 0;
    },
    closeCreateDialog() {
      this.createDialog = false;
      this.createForm = defaultCreateForm();
      this.fileMeta = null;
      this.phoneColumnPicked = false;
      this.lastUploadPayload = null;
      this.priceValue = 0;
      this.importProgress = 0;
      this.clearFileFlag = true;
      this.$nextTick(() => {
        this.clearFileFlag = false;
      });
    },

    onFileMeta(meta) {
      this.fileMeta = meta;
      const rows = Number(meta?.rowCount || 0);
      const per = Number(this.scorePrice || 0);
      this.priceValue = rows * per;
      this.phoneColumnPicked = false;
      this.lastUploadPayload = null;
    },
    onPhoneColumnSelected(payload) {
      this.phoneColumnPicked = !!payload?.phone;
      this.lastUploadPayload = payload;
    },

    async createRequest() {
      if (
        !this.canCreate ||
        !this.lastUploadPayload ||
        this.createLoading ||
        this.ingesting
      )
        return;

      const base = {
        request_name: this.createForm.name,
        rows: this.fileMeta?.rowCount ?? 0,
        price: this.priceValue,
        file_params: this.lastUploadPayload?.fileParams,

        auto_fill_bases: !!this.createForm.autoFillBases,
        auto_fill_base_mode: this.createForm.autoFillBases
          ? this.createForm.baseMode
          : 'existing',

        auto_fill_base_ids:
          this.createForm.autoFillBases &&
          this.createForm.baseMode === 'existing' &&
          this.createForm.baseId
            ? [this.createForm.baseId]
            : [],

        auto_fill_new_base_name:
          this.createForm.autoFillBases && this.createForm.baseMode === 'new'
            ? String(this.createForm.newBaseName || '').trim()
            : '',

        auto_fill_min_percent: this.createForm.autoFillBases
          ? Number(this.createForm.minPercent || 0)
          : 0,
        auto_fill_include_zero_score: this.createForm.autoFillBases
          ? !!this.createForm.autoFillIncludeZeroScore
          : false,

        auto_fill_split_base:
          this.createForm.autoFillBases && this.createForm.baseMode === 'new'
            ? !!this.createForm.splitBase
            : false,

        auto_fill_split_count: this.createForm.splitBase
          ? Number(this.createForm.splitCount || 1)
          : 1,
        auto_fill_use_source_from_file: !!this.createForm.useSourceFromFile,
        auto_fill_add_to_group: this.createForm.autoFillBases
          ? !!this.createForm.addToGroup
          : false,

        auto_fill_group_name:
          this.createForm.autoFillBases && this.createForm.addToGroup
            ? String(this.createForm.groupName || '').trim()
            : '',
        auto_fill_base_params: this.createForm.autoFillBases
          ? this.createForm.params
          : {},
      };

      const createBody = sessionStorage.token
        ? { ...base, token: sessionStorage.token }
        : base;

      try {
        this.createLoading = true;

        const resp = await this.$http.axios.post(
          '/score/requests/create',
          createBody,
        );
        const { ok, request_id } = resp.data || {};
        if (!ok || !request_id) throw new Error('create_failed');

        this.ingesting = true;
        const ingestBody = {
          request_id,
          file_params: this.lastUploadPayload.fileParams,
          phone_column: this.lastUploadPayload.phone,
          save_custom_fields: this.saveCustomFields,
          selected_custom_fields: (this.lastUploadPayload?.columns || []).map(
            (c) => c.value,
          ),
        };

        await new Promise((resolve, reject) => {
          this.$http.post(
            '/score/requests/ingest',
            ingestBody,
            () => resolve(),
            (e) => reject(e),
          );
        });

        this.closeCreateDialog();
        this.renderRequests();
      } catch (err) {
        const code = err?.response?.data?.error;
        if (code === 'insufficient_balance') {
          const b = Number(err.response.data.balance ?? 0);
          const need = Number(err.response.data.need ?? this.priceValue);
          const def = Number(err.response.data.deficit ?? need - b);
          alert(
            `Недостаточно средств.\nНа балансе: ${b.toFixed(
              2,
            )} ₽\n нужно: ${need.toFixed(2)} ₽\nне хватает: ${def.toFixed(
              2,
            )} ₽`,
          );
        } else if (code === 'group_has_no_bases') {
          alert('В выбранной группе нет баз для загрузки');
        } else {
          console.error('Create request error:', err);
          alert('Не удалось создать заявку. Попробуй ещё раз.');
        }
      } finally {
        this.createLoading = false;
        this.ingesting = false;
      }
    },

    formatData(data) {
      const mapByCode = {
        pending: 'waiting',
        processing: 'wait',
        done: '1',
        failed: 'stop',
      };
      const mapByLabel = {
        ожидает: 'waiting',
        'в обработке': 'wait',
        готово: '1',
        ошибка: 'stop',
      };

      return (Array.isArray(data) ? data : []).map((row) => {
        const newRow = { ...row };

        if (newRow.status_code != null) {
          const code = String(newRow.status_code).trim().toLowerCase();
          if (mapByCode[code]) newRow.status = mapByCode[code];
        }

        if (
          !newRow.status ||
          ![
            'wait',
            '1',
            'stop',
            '-1',
            'success',
            'waiting',
            'cancelled',
          ].includes(String(newRow.status))
        ) {
          const label = String(newRow.status || '')
            .trim()
            .toLowerCase();
          if (mapByLabel[label]) newRow.status = mapByLabel[label];
        }

        Object.keys(newRow).forEach((key) => {
          const val = newRow[key];
          if (val == null) return;

          if (/percent/i.test(key)) {
            newRow[key] = String(val).includes('%') ? String(val) : `${val}%`;
          } else if (key === 'progress') {
            const n = Number(val);
            newRow[key] = Number.isFinite(n) ? `${n}%` : String(val);
          } else if (/price/i.test(key)) {
            newRow[key] = `${val}\u00A0₽`;
          }
        });

        return newRow;
      });
    },

    normalizeRequestsFilters(filters = {}) {
      const f = { ...filters };
      const raw = f.request_name;

      if (Array.isArray(raw)) {
        f.request_name = raw
          .map((v) => (typeof v === 'object' ? v.id || v.name : v))
          .filter(Boolean);
      } else if (raw && typeof raw === 'object') {
        f.request_name = raw.id || raw.name;
      }

      return f;
    },

    renderRequests(filters = {}) {
      this.loading_requests = true;
      try {
        const body = this.normalizeRequestsFilters(filters);
        this.$http.post('/score/requests', body, (data) => {
          this.table.requests.data = this.formatData(data).map((r) => ({
            ...r,
            created_at_raw: r.created_at,
          }));
          this.loading_requests = false;
        });
      } catch (e) {
        console.error(e);
        this.loading_requests = false;
      }
    },
    renderNumbers(payload = {}) {
      payload = this.normalizeRequestsFilters(payload);
      this.loading_numbers = true;

      const touchesPercent =
        Object.prototype.hasOwnProperty.call(payload, 'score_percent_from') ||
        Object.prototype.hasOwnProperty.call(payload, 'score_percent_to');

      const touchesPeriod =
        Object.prototype.hasOwnProperty.call(payload, 'startDate') ||
        Object.prototype.hasOwnProperty.call(payload, 'endDate') ||
        Object.prototype.hasOwnProperty.call(payload, 'startTime') ||
        Object.prototype.hasOwnProperty.call(payload, 'endTime');

      const touchesName = Object.prototype.hasOwnProperty.call(
        payload,
        'request_name',
      );

      const isFilterCall = touchesPercent || touchesPeriod || touchesName;

      if (isFilterCall) {
        this.lastNumbersFilters = payload || {};
        payload.page = 1;
      }

      const page = Number(payload.page || 1);
      const per_page = Number(this.perPage || 10);
      const sortBy = (payload.sortBy && payload.sortBy[0]) || 'score_date';
      const sortDesc = Array.isArray(payload.sortDesc)
        ? !!payload.sortDesc[0]
        : true;
      const sort_dir = sortDesc ? 'desc' : 'asc';

      const body = {
        ...this.lastNumbersFilters,
        page,
        per_page,
        sort_by: sortBy,
        sort_dir,
      };

      this.$http.post(
        '/score/numbers/paged',
        body,
        (resp) => {
          this.table.numbers.data = this.formatData(resp?.rows || []);
          this.numbersTotal = Number(resp?.total || 0);
          this.loading_numbers = false;
        },
        () => {
          this.loading_numbers = false;
        },
      );
    },

    requestItemsFn(row) {
      const code = String(row?.status_code ?? '')
        .trim()
        .toLowerCase();
      const label = String(row?.status ?? '')
        .trim()
        .toLowerCase();

      const isDone = code === 'done' || code === '1' || label === 'готово';
      const isFailed =
        code === 'failed' || code === 'stop' || label === 'ошибка';

      const out = [];
      if (isDone) out.push({ title: 'Экспорт', action: 'export' });
      if (isDone || isFailed) out.push({ title: 'Удалить', action: 'delete' });
      return out;
    },
    deleteRequest(row) {
      const request_id = row?.request_id;
      if (!request_id) return;
      this.$http.post('/score/requests/delete', { request_id }, () => {
        this.renderRequests();
        this.renderNumbers();
      });
    },

    exportRequests(payload) {
      const body = sessionStorage.token
        ? { ...payload, token: sessionStorage.token }
        : payload;

      this.$http.axios
        .post('/score/numbers/export', body, { responseType: 'blob' })
        .then((res) => {
          const blob = new Blob([res.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = 'score_numbers.xlsx';
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch((err) => {
          console.error('Ошибка экспорта:', err);
          alert('Не удалось скачать отчёт');
        });
    },

    exportNumbers(payload = {}) {
      payload = this.normalizeRequestsFilters(payload);

      return this.downloadScoreExport(
        {
          ...this.lastNumbersFilters,
          ...payload,
        },
        'score_numbers.xlsx',
      );
    },
    exportExcel(url, payload, filename) {
      this.excelLoading = true;
      if (sessionStorage.token)
        payload = { ...payload, token: sessionStorage.token };
      this.$http.axios
        .post(url, payload, { responseType: 'blob' })
        .then((res) => {
          this.excelLoading = false;
          const blobUrl = URL.createObjectURL(new Blob([res.data]));
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(blobUrl);
        })
        .catch((err) => {
          this.excelLoading = false;
          console.error('Export error:', err);
          alert('Не удалось скачать отчёт');
        });
    },
  },
};
</script>

<style scoped>
.top {
  flex-direction: column;
  align-items: flex-start;
}
.api-instruction {
  display: inline-block;
  margin-top: 8px;
  color: #4b5eff;
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;
}
.api-instruction:hover {
  text-decoration: underline;
}
.my-radio-group .v-radio {
  margin-top: 8px;
  margin-bottom: 18px;
}
.score-filters ::v-deep .input_custom--select .v-input__slot {
  width: 220px !important;
  min-width: 250px !important;
  max-width: 250px !important;
  min-height: 40px !important;
  max-height: 40px !important;
}
.content_table {
  margin-top: 24px;
}
.my_toolbar {
  margin-top: 16px;
  display: flex;
  align-items: flex-end;
}
.tabs {
  flex: 1;
}
.no-wrap {
  white-space: nowrap;
}
.add {
  border: none;
  padding: 12px 20px 12px 22px;
  background: #4b5eff !important;
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  text-align: center;
  color: #eee;
  cursor: pointer;
  display: flex;
  margin-top: 24px;
  justify-content: center;
  align-items: center;
}
.add .icon {
  margin-right: 11px;
}
.item_tab {
  text-transform: none !important;
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 120%;
  color: #808185;
}
.my_active_tab {
  color: #2b2d33;
}
.blocks {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.num_big {
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 130%;
  text-align: center;
  color: #404247;
  max-width: 75px;
  position: absolute;
  top: 55px;
  width: 75px;
  left: 51px;
}
.block_item {
  padding: 16px 24px;
  border-radius: 8px;
  width: 265px;
  margin-bottom: 36px;
}
.block_item:nth-child(odd) {
  margin-right: 20px;
}
.small_blocks {
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  justify-content: center;
}
.block_item .heading {
  font-weight: 600;
  font-size: 17px;
  line-height: 120%;
  color: #404247;
  margin-bottom: 12px;
  text-align: left;
}
.block_item .num {
  font-weight: 800;
  font-size: 24px;
  line-height: 130%;
  color: #404247;
  text-align: left;
}
.my_red .num {
  color: #ee505a;
}
.my_gray {
  background: #f8f8f8;
}
.my_red {
  background: #fdeeee;
}
.my_green {
  background: #e8f7f4;
}
.block {
  display: flex;
  flex-wrap: wrap;
  padding: 32px 24px;
  justify-content: center;
  max-width: 600px;
}
.big_block {
  background: #e8f7f4;
  border-radius: 8px;
  display: flex;
  padding: 24px 16px;
  min-width: 500px;
  max-height: 230px;
}
.right {
  margin-left: 32px;
}
.heading {
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  text-align: left;
  line-height: 130%;
  color: #404247;
}
.robot,
.client,
.silence {
  text-align: left;
  position: relative;
  margin-top: 24px;
  font-weight: 500;
  font-size: 17px;
  padding-left: 25px;
  line-height: 120%;
  color: #404247;
}
.robot:before {
  content: '';
  width: 18px;
  height: 18px;
  background: #faa373;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 0;
  display: block;
}
.client:before {
  content: '';
  width: 18px;
  height: 18px;
  background: #57b6ed;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 0;
  display: block;
}
.silence:before {
  content: '';
  width: 18px;
  height: 18px;
  background: #9a99fb;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 0;
  display: block;
}
.content {
  height: 100%;
  display: flex;
  position: relative;
  z-index: 1000;
}
.empty {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 500px;
}
.subtitle {
  max-width: 450px;
  margin-bottom: 32px;
}
.left {
  position: relative;
}
.wrapper {
  padding: 32px;
}
.subtitle {
  font-style: normal;
  text-align: left;
  font-weight: 700;
  font-size: 17px;
  line-height: 120%;
  margin-top: 24px;
  color: #404247;
  margin-bottom: 0;
}
.textarea {
  padding: 16px 0;
}
.rules {
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 130%;
  color: #aaabad;
  text-align: left;
  margin-bottom: 8px;
}
.add_modal {
  width: 100%;
  padding: 9px;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 110%;
  color: #2b2d33;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.add_modal:hover {
  background-color: #f0f0f0;
}
.opacity-50 {
  opacity: 0.5;
}
.pointer-events-none {
  pointer-events: none;
}
.wrapper {
  position: relative;
  padding: 32px;
}
.dialog-close {
  color: #808185;
}
.dialog-close:hover {
  color: #2b2d33;
}
.snm {
  --c-text: #2b2d33;
  --c-muted: #808185;
  --c-line: #d9dade;
  --c-accent: #4b5eff;
}

.snm.modal-card {
  position: relative;
  background: #fff;
  padding: 32px 32px 28px;
  border-radius: 12px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.14);
}

.snm .close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  min-width: 36px;
  height: 36px;
}
.snm .close-btn .v-icon {
  font-size: 20px;
  color: #9c9da1;
}

.snm .modal-title {
  margin: 0 0 20px;
  font: 800 24px/1.2 Manrope, system-ui, sans-serif;
  text-align: left;
  color: var(--c-text);
}

.snm .form-control {
  margin-top: 16px;
}
.snm .field-label {
  font: 600 15px/1.2 Manrope, sans-serif;
  color: #404247;
  margin-bottom: 6px;
  text-align: left;
}
.snm .muted {
  color: var(--c-muted);
  text-align: left;
}

.snm .actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.primary-btn {
  background: #4b5eff !important;
  color: #fff !important;
  font: 800 16px/1.1 Manrope, sans-serif;
  border-radius: 12px !important;
  text-transform: none;
  letter-spacing: 0;
  box-shadow: none !important;
}
.primary-btn.v-btn--disabled {
  opacity: 0.6 !important;
}

.ghost-btn {
  background: #fff !important;
  color: #2b2d33 !important;
  border: 1px solid var(--c-line) !important;
  font: 800 16px/1.1 Manrope, sans-serif;
  border-radius: 12px !important;
  text-transform: none;
  letter-spacing: 0;
  box-shadow: none !important;
}
.ghost-btn:hover {
  background: #f5f6f8 !important;
}
.ghost-btn.v-btn--disabled {
  opacity: 0.6 !important;
}

.snm .actions .v-btn {
  min-width: 120px;
  padding: 0 18px;
}
.add {
  border: none;
  padding: 12px 20px 12px 22px;
  background: #4b5eff !important;
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  text-align: center;
  color: #fff;
  cursor: pointer;
  display: flex;
  margin-top: 24px;
  justify-content: center;
  align-items: center;
}

.wrapper {
  position: relative;
  padding: 32px;
}
.dialog-close {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 36px;
  height: 36px;
  color: #808185;
}
.dialog-close:hover {
  color: #2b2d33;
}

.snm .close-btn {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 36px;
  height: 36px;
}
.min-percent {
  margin-top: 10px;
}

.min-percent__label {
  font-style: normal;
  font-weight: 700;
  font-size: 17px;
  line-height: 120%;
  color: #404247;
  text-align: center;
  margin-bottom: 6px;
}

.min-percent__value {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 130%;
  color: #000000;
  text-align: center;
  margin-top: -4px;
  margin-bottom: 14px;
}

.min-percent__slider {
  margin-top: 2px;
}

.min-percent__slider ::v-deep .v-slider__track-fill {
  background-color: #4b5eff !important;
}
.min-percent__slider ::v-deep .v-slider__thumb {
  background-color: #4b5eff !important;
  border-color: #4b5eff !important;
}
.min-percent__slider ::v-deep .v-slider__tick-label {
  color: #aaabad !important;
}
.min-percent__slider ::v-deep .v-slider__thumb-label {
  background: #4b5eff !important;
  color: #fff !important;
  font-weight: 600;
}
@media (max-width: 650px) {
  .my_toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .my_toolbar .tabs {
    width: 100%;
  }

  .my_toolbar .add {
    align-self: center;
    width: auto;
    min-width: 150px;
    height: 40px;
    margin-top: 12px;
    padding: 8px 16px;
    font-size: 14px;
    border-radius: 6px;
    justify-content: center;
  }
}
.rules--error {
  color: #e5484d;
  background: #fff1f1;
  border-radius: 8px;
  padding: 8px 12px;
  text-align: center;
  margin-top: 12px;
}
.zero-score-checkbox {
  margin-top: 18px;
  margin-bottom: 18px;
}

.zero-score-checkbox ::v-deep .v-input__slot {
  margin-bottom: 0;
}

.score-base-params {
  margin-top: 14px;
  margin-bottom: 14px;
}
.score-export-notice ::v-deep .v-snack__wrapper {
  border: 1px solid #dfe2f2;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(43, 45, 51, 0.12);
}
.score-export-notice-content {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #2b2d33;
}
</style>
